module.exports = __webpack_public_path__ + "static/media/zq_ysbq.fb64d2db.png";